import {
  authenticatedFastApiAxiosInstance,
  authenticatedFastApiAxiosInstanceAllowEmptyString,
} from "@/lib/data/http";
import {
  baseFastApiMedicalTreatmentRoute,
  baseFastApiMatterRoute,
} from "@/lib/data/requests/matters/matter";
import { serializeMedicalTreatmentRecordPayload } from "@/lib/data/requests/matters/medical-treatment-payloads";
import type {
  APIResponse,
  MedicalTreatmentRecord,
  SourceOwnedConnectionCreate,
} from "@/lib/types";

export const createMedicalTreatmentRecordV3 = (
  data: Pick<MedicalTreatmentRecord, "matterId"> &
    Partial<Omit<MedicalTreatmentRecord, "connections">> & {
      connections?: SourceOwnedConnectionCreate[];
    },
) => {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<MedicalTreatmentRecord>>(
      "matters/v4/medical-treatments/records",
      {
        ...serializeMedicalTreatmentRecordPayload(data),
        connections: data.connections ?? [],
      },
    )
    .then((res) => res.data);
};

export const updateMedicalTreatmentRecordV1 = (
  data: Pick<MedicalTreatmentRecord, "id" | "dateModified"> &
    Partial<MedicalTreatmentRecord>,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .patch<
      APIResponse<MedicalTreatmentRecord>
    >(`${baseFastApiMedicalTreatmentRoute}/records`, serializeMedicalTreatmentRecordPayload(data))
    .then((res) => res.data);
};

export const deleteMedicalTreatmentRecordV1 = (
  data: Pick<MedicalTreatmentRecord, "id" | "matterId">,
) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MedicalTreatmentRecord>
    >(`${baseFastApiMatterRoute}/medical-treatments/records/${id}`)
    .then((res) => res.data);
};
